











import { defineComponent, PropType } from "@vue/composition-api"
export default defineComponent({
  props: {
    hideLayout: Object as PropType<Record<string, boolean>>,
  },
})
